/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UserRequestPasswordResetInput = {
    email: string;
};
export type RequestPasswordResetFormMutationVariables = {
    input: UserRequestPasswordResetInput;
};
export type RequestPasswordResetFormMutationResponse = {
    readonly userRequestPasswordReset: {
        readonly success: boolean;
    };
};
export type RequestPasswordResetFormMutation = {
    readonly response: RequestPasswordResetFormMutationResponse;
    readonly variables: RequestPasswordResetFormMutationVariables;
};



/*
mutation RequestPasswordResetFormMutation(
  $input: UserRequestPasswordResetInput!
) {
  userRequestPasswordReset(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserRequestPasswordResetPayload",
    "kind": "LinkedField",
    "name": "userRequestPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestPasswordResetFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestPasswordResetFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea3e2eb3234b694b71f66a187ca9a1f6",
    "id": null,
    "metadata": {},
    "name": "RequestPasswordResetFormMutation",
    "operationKind": "mutation",
    "text": "mutation RequestPasswordResetFormMutation(\n  $input: UserRequestPasswordResetInput!\n) {\n  userRequestPasswordReset(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '7760edc19699fe66470f9f653a8dc4f1';
export default node;
